import { FC } from 'react'
import styled from 'styled-components'

import {
  AttributeSection,
  Exclamation,
  SizeSelector,
  TypeStyleBodyMicro,
} from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { useAccentColor } from '../../../../../../containers/AccentColorContainer'
import { trackEvent } from '../../../../../../lib/analytics'
import { EmbroiderySectionWrapper } from '../../../../../embroidery/EmbroiderySectionWrapper'

import { IProps } from './IProps'
import { SizeChart } from './SizeChart'
import { SizeSelection } from './SizeSelection'

const category = 'product details'

/**
 * @deprecated Use VariantSelectionForm composable components from app directory instead.
 */
export const SizesSection: FC<IProps> = ({
  minWidthStyle,
  hideTitle,
  isInvalid = false,
  isProductWaitlistable,
  onSizeSelect,
  selectedSize,
  sizeChart,
  sizes,
  disableMobileHorizontalSwipe,
  ...rest
}) => {
  const {
    sizesSection: { title, sizeSoldOutErrorMessage, sizeNotSelectedErrorMessage },
  } = useTranslation()
  const { accentColor } = useAccentColor()
  const sectionTitle = hideTitle ? undefined : title
  const endAdornment = <SizeChart category={category} sizeChart={sizeChart} hideTitle={hideTitle} />

  const selection = (
    <SizeSelection
      selectedSize={selectedSize}
      isProductWaitlistable={isProductWaitlistable}
      category={category}
      hideTitle={hideTitle}
    />
  )
  const hasError = Boolean(isInvalid || (selectedSize?.soldOut && !isProductWaitlistable))
  return (
    <EmbroiderySectionWrapper {...rest} data-testid='size-picker' className='size-section'>
      <AttributeSection
        title={sectionTitle}
        selection={selection}
        className='size-section-title'
        endAdornment={endAdornment}
        tabIndex={-1}
        data-has-error={hasError}
      >
        <SizeSelector
          accentColor={accentColor}
          minWidthStyle={minWidthStyle}
          sizes={sizes}
          disableMobileHorizontalSwipe={disableMobileHorizontalSwipe}
          selected={selectedSize}
          onSelectSize={onSizeSelect}
          {...trackEvent({
            category,
            action: 'select size',
            label: selectedSize?.shorthand ?? 'not selected',
            value: selectedSize?.shorthand ?? 'not selected',
          })}
        />
      </AttributeSection>
      {hasError && (
        <ErrorMessageWrapper>
          <Exclamation />
          <div role='alert' aria-live='polite'>
            {selectedSize?.soldOut ? sizeSoldOutErrorMessage : sizeNotSelectedErrorMessage}
          </div>
        </ErrorMessageWrapper>
      )}
    </EmbroiderySectionWrapper>
  )
}

const ErrorMessageWrapper = styled(TypeStyleBodyMicro)`
  margin-top: ${o => o.theme.spacing(2)};
  color: ${o => o.theme.color.stroke.critical.text.on.subtle};
  display: flex;
  font-weight: 600;
  align-items: center;
  gap: ${o => o.theme.spacing(2)};
`
